// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__19e8g","amount":"Amount_amount__3YReD","tip":"Amount_tip__NeFzO","tipHeader":"Amount_tipHeader__2V8zk","tipsWrap":"Amount_tipsWrap__bwgTZ"};